import React from 'react'

const Avatar = ({src}) => (
  <div className='flex justify-center items-center'>
    <img src={src} alt='avatar'/>
  </div>
)

export default Avatar



// WEBPACK FOOTER //
// src/components/Avatar/Avatar.js